// INFO: This Component is designed to be slotted into the Actions.cell.tsx component
// but can also be used anywhere we are using a MUI Menu component and want icons + text + navigation
import { type SvgIconComponent } from "@mui/icons-material";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";

interface IconMenuLinkProps {
  label: string;
  Icon: SvgIconComponent;
  enabled?: boolean;
  onClick?: () => void;
  to: string;
}

const IconMenuLink = ({
  onClick,
  Icon,
  label,
  enabled = true,
  to = "",
}: IconMenuLinkProps) => {
  if (!enabled) return;

  return (
    <MenuItem onClick={onClick} component={Link} to={to}>
      <ListItemIcon>
        <Icon color="action" />
      </ListItemIcon>
      <ListItemText>{label}</ListItemText>
    </MenuItem>
  );
};
export default IconMenuLink;
